import { translationLangaugeResource } from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

/**
 * Client-side API wrapper for translation resource endpoints.
 */
export class TranslationsApi {
  /**
   * Loads translation resources.
   *
   * @param successCallback Invoked with translation resources on success.
   * @param failureCallback Invoked with an error message on failure.
   * @param signal Abort signal used to cancel the request.
   */
  async getTranslations(
    successCallback: (resources: translationLangaugeResource[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = '/api/translations';

    await new ApiHelper().getDataAsync(
      dataUrl,
      successCallback,
      failureCallback,
      signal
    );
  }
}
